import { gql } from 'graphql-tag';

/**
 * GraphQL query to get a single litter by ID
 */
export const GET_LITTER = gql`
  query GetLitter($id: ID!) {
    getLitter(id: $id) {
      id
      name
      litterType
      expectedMatingDate
      expectedDueMonth
      expectedDueDate
      expectedPuppyDate
      dobOfPuppies
      sireId
      damId
      sire {
        id
        name
        longName
      }
      dam {
        id
        name
        longName
      }
      numberOfPuppies
      availablePuppies
      limitedRegistrationPrice
      mainRegistrationPrice
      expectedColors
      content
      coverImgUrl
      imagesUrls
      createdAt
      updatedAt
    }
  }
`;

/**
 * GraphQL query to get multiple litters with optional filtering
 */
export const GET_LITTERS = gql`
  query GetLitters($filter: LitterFilter) {
    getLitters(filter: $filter) {
      id
      name
      litterType
      expectedMatingDate
      expectedDueMonth
      expectedDueDate
      expectedPuppyDate
      dobOfPuppies
      sireId
      damId
      sire {
        id
        name
        longName
      }
      dam {
        id
        name
        longName
      }
      numberOfPuppies
      availablePuppies
      limitedRegistrationPrice
      mainRegistrationPrice
      expectedColors
      content
      coverImgUrl
      imagesUrls
      createdAt
      updatedAt
    }
  }
`;

/**
 * GraphQL mutation to create a new litter
 */
export const ADD_LITTER = gql`
  mutation AddLitter($input: LitterInput!) {
    addLitter(input: $input) {
      id
      name
      litterType
      expectedMatingDate
      expectedDueMonth
      expectedDueDate
      expectedPuppyDate
      dobOfPuppies
      sireId
      damId
      sire {
        id
        name
        longName
      }
      dam {
        id
        name
        longName
      }
      numberOfPuppies
      availablePuppies
      limitedRegistrationPrice
      mainRegistrationPrice
      expectedColors
      content
      coverImgUrl
      imagesUrls
      createdAt
      updatedAt
    }
  }
`;

/**
 * GraphQL mutation to update an existing litter
 */
export const EDIT_LITTER = gql`
  mutation EditLitter($id: ID!, $input: LitterInput!) {
    editLitter(id: $id, input: $input) {
      id
      name
      litterType
      expectedMatingDate
      expectedDueMonth
      expectedDueDate
      expectedPuppyDate
      dobOfPuppies
      sireId
      damId
      sire {
        id
        name
        longName
      }
      dam {
        id
        name
        longName
      }
      numberOfPuppies
      availablePuppies
      limitedRegistrationPrice
      mainRegistrationPrice
      expectedColors
      content
      coverImgUrl
      imagesUrls
      createdAt
      updatedAt
    }
  }
`;

/**
 * GraphQL mutation to delete a litter
 */
export const DELETE_LITTER = gql`
  mutation DeleteLitter($id: ID!) {
    deleteLitter(id: $id)
  }
`;
